import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './personalDetails';
import DocumentDetails from './documentDetails';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';

const AgentMasterCreate = () => {
    const apiService = new LeaseApiService();
    let navigate = useNavigate()

    const { currencyPrecision } = useCurrency();
    const userName = useSelector(getName);
    const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
    const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
    const [activeFY, setActiveFY] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false]);
    const [loading, setloader] = useState(false)
    const [documentsList, setDocumentsList] = useState([])
    const [customerTypeList, setCustomerTypeList] = useState([]);
    const [salesPersonList, setSalesPersonList] = useState([]);
    const [documentType, setDocumentType] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);

    const validationRules = [
        { key: "type", message: "Please Select Type from Personal Details" },
        { key: "title", message: "Please Select Title from Personal Details" },
        { key: "firstName", message: "Please Enter FullName" },
        { key: "mobileNo", message: "Please Enter Mobile No" },
        { key: "email", message: "Please Enter Email" },
        { key: "leadtype", message: "Please Enter Lead Type" },
        { key: "nationality", message: "Please Enter Nationality" },
        { key: "source", message: "Please Enter Source" },
        // { key: "subsource", message: "Please Enter Sub Source" },
        { key: "salesPerson", message: "Please Enter Sales Person" },
        // { key: "dateofBirth", message: "Please Enter Date Of Birth" },
    ];
    const [transectionData, setTransectionData] = useState({
        type: null,
        mobileNo: '',
        id: '',
        phoneNo: '',
        name: '',
        email: '',
        address: '',
        commissionRate: '',
        contactPerson: '',
        interCommRate: '',
        supplier: null,
        active: true,
        agreementDate: '',
        salePerson: null,
        consultant: false,
        limit: '',
    });
    useEffect(() => {
        fetchDropdownData()
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'CustSource,SalesPersons,CustomerType,CustTitles,CustSource,CustAgents,LeadType,ActivityRating,CustPackageNames,PersonalTabLeadType');
            const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
            setCustomerTypeList(res?.data?.dropdowns?.CustomerType)
            setSalesPersonList(res?.data?.dropdowns?.SalesPersons)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            for (const rule of validationRules) {
                if (!transectionData?.[rule.key]) {
                    setloader(false);
                    toast.warning(rule.message);
                    return;
                }
            }
            if (!/^\S+@\S+\.\S+$/.test(transectionData.email)) {
                setloader(false);
                toast.warning("Please Enter Valid Email");
                return;
            }
            let fullName = (transectionData?.firstName + " " + transectionData?.lastName)
            const validParam = new URLSearchParams();
            validParam.append('Action', 'CheckPrimaryContact');
            validParam.append('TenantNo', '0');
            validParam.append('TenantName', fullName);
            validParam.append('CustomerType', transectionData?.countryCode?.dialCode);
            validParam.append('UnitRefNo', transectionData?.mobileNo);
            const validRes = await apiService.getApiParamater('CUSTOMER_COMMON', `?${validParam.toString()}`);
            const value = Object.values(validRes?.result?.data || {})[0];
            if (value) {
                setloader(false);
                toast.warning("User with this name already exists");
                return;
            }
            const countryCode = transectionData?.countryCode?.dialCode?.toString() || "";

            const phoneWithoutCode = transectionData?.mobileNo?.toString().startsWith(countryCode)
                ? transectionData.mobileNo.toString().slice(countryCode.length)
                : transectionData.mobileNo;
            
            let customerMaster = {
                record_id: 0,
                exp2: transectionData.lastNameAR || "",
                exp3: currentDatetimeUTC,
                modify_by: userName || "",
                modify_on: currentDatetimeUTC,
                createdBy: userName || "",
                createdOn: currentDatetimeUTC,
                leadtype: transectionData.leadtype?.label || "0"
            }
            const body = {
                customerMain: {
                    customerMaster: customerMaster,
                    custNo: "0",
                    rblExpiredDocs: "0"
                }
            };
            
            const postRes = await apiService.post('POST_CUSTOMER', body);
            if (postRes?.data?.statusCode === 201) {
                toast.success(postRes?.data?.message);
                setloader(false);
                navigate('/Customer/Property/Master/Customer/Listing')
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    return (
        <div className='p-3'>
            <div className='border-box2 p-2 d-flex justify-content-between' style={{ borderRadius: "8px" }}>
                <div className=''><h6>Agent Master</h6></div>
                <div className='d-flex gap-3'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnSecondary flex-end gap-2' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Personal Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)} >Attachment
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (<PersonalDetails tableLoading={tableLoading} customerTypeList={customerTypeList} salesPersonList={salesPersonList}
                setTransectionData={setTransectionData} rowData={rowData}
                transectionData={transectionData}
                defaultCountry={defaultCountry} />)}
            {gridVisibility[1] && (<DocumentDetails documentType={documentType} setDocumentsList={setDocumentsList} documentsList={documentsList} />)}
        </div>

    );
};
export default AgentMasterCreate;